export enum Tone {
  Positive = "positive",
  Neutral = "neutral",
  Mixed = "mixed",
  Negative = "negative",
}

const Colors: Record<Tone, string> = {
  [Tone.Negative]: "#E64C65",
  [Tone.Positive]: "#1FAA7A",
  [Tone.Neutral]: "#B4B1BA",
  [Tone.Mixed]: "#66F",
};

export function getToneColor(tone: Tone): string {
  return Colors[tone];
}

export function getAllTones() {
  return Object.keys(Tone)
    .map((k) => Tone[k as keyof typeof Tone])
    .map((v) => v as Tone);
}
